import * as React from "react";
import { Stack, Typography } from "@mui/material";
import { Header } from "../../components/atoms/Header";
import { Hr } from "../../components/atoms/HR";
import { colors } from "../../styles/constants";
import { ServiceProvider, ServiceProviderType } from "@/types/index";
import { useBrandingContext } from "@/contexts/BrandingContext";

export type ExpressFormHeaderProps = {
  readonly serviceProvider: ServiceProvider;
};

export const ExpressFormHeader: React.FC<ExpressFormHeaderProps> = ({ serviceProvider }) => {
  const { brand } = useBrandingContext();

  return (
    <Stack rowGap={4}>
      <Stack rowGap={2}>
        <div></div>

        <Header level={1} color={colors.primaryText}>
          Notify {serviceProvider.companyName} of a bereavement
        </Header>

        {serviceProvider.expressFormLandingCopy ? (
          <Stack
            className="embedded-html"
            rowGap={2}
            dangerouslySetInnerHTML={{ __html: serviceProvider.expressFormLandingCopy }}
          ></Stack>
        ) : (
          <>
            <Typography variant="body1">
              {serviceProvider.inPartnership
                ? `${serviceProvider.companyName} has partnered with ${brand} to make `
                : `${brand} makes`}
              the process of closing or transferring a bereavement{" "}
              {serviceProvider.serviceProviderType === ServiceProviderType.Insurance
                ? "policy"
                : "account"}{" "}
              as simple as possible. Please fill in the details below, and our Customer Service team
              will act on your request.
            </Typography>

            <Typography variant="body1">
              You can also use this form to notify all other companies of the death in one go
              (banks, insurers, utilities etc), and to receive updates in one, secure place.
            </Typography>
          </>
        )}
      </Stack>

      <Hr />
    </Stack>
  );
};
